import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { wsUrl } from "@/lib/api";

const RealtimeContext = createContext({ connected: false });

export function RealtimeProvider({ children }) {
  const qc = useQueryClient();
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);
  const retryRef = useRef(null);

  useEffect(() => {
    let closed = false;

    const connect = () => {
      try {
        const ws = new WebSocket(wsUrl());
        wsRef.current = ws;
        ws.onopen = () => setConnected(true);
        ws.onclose = () => {
          setConnected(false);
          if (!closed) retryRef.current = setTimeout(connect, 3000);
        };
        ws.onerror = () => ws.close();
        ws.onmessage = () => {
          // Any change on the backend -> refresh all live data
          qc.invalidateQueries();
        };
      } catch {
        retryRef.current = setTimeout(connect, 3000);
      }
    };
    connect();

    return () => {
      closed = true;
      clearTimeout(retryRef.current);
      wsRef.current?.close();
    };
  }, [qc]);

  return <RealtimeContext.Provider value={{ connected }}>{children}</RealtimeContext.Provider>;
}

export const useRealtime = () => useContext(RealtimeContext);
